import React from 'react'
import css from './AboutMissionValue.module.css';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';
import personalConnection from '../../../../../assets/hearts-hover-pinch.gif';
import culturalAppreciation from '../../../../../assets/cultural-appreciation.gif';
import continuousGrowth from '../../../../../assets/continuous-growth.gif';
import { FormattedMessage, useIntl } from '../../../../../util/reactIntl';

function AboutMissionValue() {
  const intl = useIntl();
  const missionItems = [
    {
      icon: personalConnection,
      titleId: 'AboutMissionValue.item1.title',
      descId: 'AboutMissionValue.item1.desc',
      altId: 'AboutMissionValue.item1.alt',
    },
    {
      icon: culturalAppreciation,
      titleId: 'AboutMissionValue.item2.title',
      descId: 'AboutMissionValue.item2.desc',
      altId: 'AboutMissionValue.item2.alt',
    },
    {
      icon: continuousGrowth,
      titleId: 'AboutMissionValue.item3.title',
      descId: 'AboutMissionValue.item3.desc',
      altId: 'AboutMissionValue.item3.alt',
    },
  ];

  return (
    <div className={css.missionWrapper}>
      <div className={css.missionLeft}>
        <ul>
          {missionItems.map((item, i) => {
            return (
              <li key={i}>
                <div className={css.missionIcon}>
                  <span className={css.icon}>
                    <img
                      src={item.icon}
                      alt={
                        intl.formatMessage({ id: item.altId }) || intl.formatMessage({ id: item.titleId })
                      }
                    />
                  </span>
                </div>
                <div className={css.listHeadCard}>
                  <h3>
                    <FormattedMessage id={item.titleId} />
                  </h3>
                  <p>
                    <FormattedMessage id={item.descId} />
                  </p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      <div className={css.missionRight}>
        <div className={css.missionMainHeading}>
          <FormattedMessage id="AboutMissionValue.mainHeading" />
        </div>
        <div className={css.missionHeading}>
          <FormattedMessage id="AboutMissionValue.heading" />
        </div>
        <div className={css.missionDescription}>
          <FormattedMessage id="AboutMissionValue.description" />
        </div>
        <div className={css.valueBook}>
          <IconCard type="book" />
        </div>
      </div>
    </div>
  )
}

export default AboutMissionValue